import React from 'react';
import { twMerge } from 'tailwind-merge'

interface ButtonProps {
  title: React.ReactNode;
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'tertiary';
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  icon?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
}

export const Button = ({
  title,
  onClick,
  variant = 'primary',
  disabled = false,
  loading = false,
  type = 'button',
  className = '',
  icon
}: ButtonProps) => {
  const baseStyles = 'inline-flex items-center justify-center gap-4 px-6 py-2 rounded-md transition-all duration-300 font-semibold relative overflow-hidden';

  const variantStyles = {
    primary: 'bg-gradient-to-r from-teamcare-cyan to-teamcare-cyan-dark border border-black border-2 text-white shadow-[2px_2px_0_0_rgba(0,0,0,100)] disabled:opacity-50 disabled:cursor-not-allowed hover:shadow-[4px_4px_0_0_rgba(0,0,0,100)] hover:-translate-y-0.5 active:shadow-[1px_1px_0_0_rgba(0,0,0,100)] active:translate-y-0 bg-[length:200%_100%] hover:bg-[position:100%_0] animate-gradient-shift',
    secondary: 'border border-gray-300 text-gray-700 hover:bg-gray-50',
    tertiary: 'bg-secondary-900 text-white rounded-xl hover:bg-secondary-800 active:bg-secondary-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200'
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={twMerge(`${baseStyles} ${variantStyles[variant]} ${className}`)}
    >
      {loading ? <span className="loading loading-spinner loading-sm" /> : <>
        {icon}
        <span>{title}</span>
      </>}
    </button>
  );
};
